import { render, staticRenderFns } from "./DiceRollerWindow.vue?vue&type=template&id=618a6ae9&"
import script from "./DiceRollerWindow.vue?vue&type=script&lang=ts&"
export * from "./DiceRollerWindow.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports